import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';

export default function activeVirtualKeyboard(
  currentElement = '[name="password"]',
  usernameElement = '[name="username"]',
  keyboardDiv = '.simple-keyboard',
  keyboardContainer = '#keyboard-container',
) {
  /**
   * Default input name
   * @type {string}
   */
  let layoutName = 'default';

  const portuguese = {
    default: [
      "1 2 3 4 5 6 7 8 9 0 ' \u002b {bksp}",
      'q w e r t y u i o p \u00ba \u00b4',
      '{lock} a s d f g h j k l \u00e7 \u007e \u005c',
      '{shift} < z x c v b n m , . - {shift}',
    ],
    shift: [
      '! " # $ % & / ( ) = ? \u002a {bksp}',
      'Q W E R T Y U I O P \u00aa \u0060',
      '{lock} A S D F G H J K L \u00c7 \u005e \u007c',
      '{shift} > Z X C V B N M ; : _ {shift}',
    ],
  };

  const english = {
    default: [
      ' 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p [ ]',
      '{lock} a s d f g h j k l ; \u0027',
      '{shift} \\ z x c v b n m , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '¬ ! £ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P { }',
      '{lock} A S D F G H J K L : "',
      '{shift} | Z X C V B N M < > ? {shift}',
      '.com @ {space}',
    ],
  };

  const locale = document.documentElement.lang;
  let selectedLayout = portuguese;
  if (locale === 'pt') {
    selectedLayout = portuguese;
  }
  if (locale === 'en') {
    selectedLayout = english;
  }

  if (document.querySelector('[data-keyboard-count]')) {
    let i;
    let keyboardLayout = '';
    for (i = 0; i <= document.querySelector('[data-keyboard-count]').getAttribute('data-keyboard-count'); i++) {
      if (i === 0) {
        keyboardLayout = document.querySelector(keyboardContainer).getAttribute(`data-keyboard-layout${i}`);
      } else {
        keyboardLayout += ` ${document.querySelector(keyboardContainer).getAttribute(`data-keyboard-layout${i}`)}`;
      }
    }
    keyboardLayout += ' {bksp}';
    selectedLayout = {
      default: [
        keyboardLayout,
      ],
      shift: [
        keyboardLayout,
      ],
    };
  }

  const keyboard = new Keyboard({
    onChange: input => onChange(input),
    onKeyPress: button => onKeyPress(button),
    theme: 'hg-theme-default grey-theme',
    layout: selectedLayout,
    display: {
      '{bksp}': '⌫',
    },
  });

  const inputElement = document.querySelector(currentElement);
  const usernameInput = document.querySelector(usernameElement);
  const keyboardElement = document.querySelector(keyboardDiv);

  inputElement.addEventListener('input', (event) => {
    const target = event.currentTarget;
    if (keyboardElement.style.display !== 'none') {
      inputElement.blur();
      keyboard.setInput(target.value, target.id);
    } else {
      inputElement.focus();
    }
  });

  inputElement.addEventListener('focus', (event) => {
    const target = event.currentTarget;
    if (keyboardElement.style.display !== 'none') {
      inputElement.blur();
      keyboard.setOptions({
        inputName: target.id,
      });
    } else {
      inputElement.focus();
    }
  });

  usernameInput.addEventListener('focus', () => {
    if (keyboardElement) {
      keyboardElement.style.display = 'none';
      keyboardElement.hidden = true;
    }
  });

  function onChange(input) {
    inputElement.value = input;
  }

  function onKeyPress(button) {
    /**
     * Shift functionality
     */
    if (button === '{lock}' || button === '{shift}') {
      handleShiftButton();
    }
  }

  /**
   * Handles shift functionality
   */
  function handleShiftButton() {
    const layout = layoutName;
    const shiftToggle = layout === 'default' ? 'shift' : 'default';

    layoutName = shiftToggle;
    keyboard.setOptions({
      layoutName: shiftToggle,
    });
  }
}
